import { Route } from '@/app/router'
import QuantityDisabled from '@/middleware/QuantityDisabled'

const GroupedSales = () => import('./index.vue')

const GroupedSalesMeta = {
	sort: 6,
	displayInSidebar: true,
	displayName: 'grouped-sale',
	icon: 'fal car-side',
	activeIcon: 'fas car-side'
}
const GroupedSalesProps = ['page', 'perPage']

export default new Route('/grouped-sales', GroupedSales)
	.as('Dashboard:GroupedSales')
	.meta(GroupedSalesMeta)
	.props(GroupedSalesProps)
	.permissions(['VIEW_GROUPED_SALE', 'PARTS_QUANTITY_DISABLED', 'SHOW_GROUPED_SALES'])
	.middlewares(QuantityDisabled)
